import { makeAutoObservable } from 'mobx';
import { PricingMethod } from 'api';
import { IOptions } from 'common/types/common.types';

export const isHasPrice: PricingMethod[] = [PricingMethod.Relaxed, PricingMethod.Strict];

class PzuStore {
  isPriceMenuVisible: boolean = false;

  passportSn: string = '';

  pzus: IOptions[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  toggleIsPriceMenuVisible = (pricingMethod: PricingMethod) => {
    this.isPriceMenuVisible = isHasPrice.includes(pricingMethod);
  };

  toggleSetPzus = (pzus: IOptions[]) => {
    this.pzus = pzus;
  };

  toggleGetPzus = () => this.pzus;

  setPassportSn = (passport: string) => {
    this.passportSn = passport;
  };
}

export default new PzuStore();
